module.exports = function(it, Constructor, name){
  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/babel-runtime/~/core-js/library/modules/$.strict-new.js
// module id = 823
// module chunks = 0